import { useEffect, useState } from "react";

const TICK_MS = 30_000;

/** Current time, re-rendering every `tickMs` (relative timestamps and SLA timers). */
export function useNow(tickMs = TICK_MS): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => {
      setNow(Date.now());
    }, tickMs);
    return () => {
      clearInterval(timer);
    };
  }, [tickMs]);
  return now;
}
